import { ColumnsFactory } from "../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.NumericColumn("Cod. Concepto", "idConcepto"),
    ColumnsFactory.TextColumn("Concepto", "concepto"),
    ColumnsFactory.BooleanColumn("Ingeniería", "esIngenieria"),
    ColumnsFactory.DecimalColumn("Margen(%)", "margen", {ipkTotalizar: false})
  ];
};
